import { create } from 'zustand';

type DemoStore = {
  showPhoneTriageDemo: boolean;
  setDemoStoreState: (
    state: Partial<Pick<DemoStore, 'showPhoneTriageDemo'>>
  ) => void;
};

export const useDemoStore = create<DemoStore>((set) => ({
  showPhoneTriageDemo: false,
  setDemoStoreState: (state) => set(state),
}));
